var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.75vw",
    height: "2.5vh",
    viewBox: "0 0 1 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95754 17.7911C8.7404 17.7911 9.37504 17.1564 9.37504 16.3736C9.37504 15.5907 8.7404 14.9561 7.95754 14.9561C7.17468 14.9561 6.54004 15.5907 6.54004 16.3736C6.54004 17.1564 7.17468 17.7911 7.95754 17.7911Z",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 17.7911C14.9162 17.7911 15.5508 17.1564 15.5508 16.3736C15.5508 15.5907 14.9162 14.9561 14.1333 14.9561C13.3505 14.9561 12.7158 15.5907 12.7158 16.3736C12.7158 17.1564 13.3505 17.7911 14.1333 17.7911Z",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67183 5.12884L6.34683 10.4322C6.60433 11.2472 6.73266 11.6547 6.98016 11.9563C7.19683 12.223 7.47933 12.4288 7.7985 12.5563C8.161 12.7005 8.58766 12.7005 9.44266 12.7005H12.6552C13.5102 12.7005 13.9368 12.7005 14.2985 12.5563C14.6185 12.4288 14.9002 12.223 15.1177 11.9563C15.3643 11.6547 15.4927 11.2472 15.751 10.4322L16.0918 9.35218L16.2918 8.71384L16.5677 7.83884C16.6661 7.52676 16.6896 7.19588 16.6364 6.87301C16.5831 6.55014 16.4545 6.24435 16.261 5.98044C16.0675 5.71652 15.8146 5.50189 15.5227 5.35394C15.2309 5.20598 14.9082 5.12887 14.581 5.12884H4.67183ZM4.67183 5.12884L4.66266 5.09801C4.62747 4.98014 4.58857 4.86342 4.546 4.74801C4.37729 4.32096 4.09119 3.95036 3.72077 3.67903C3.35034 3.4077 2.91071 3.24671 2.45266 3.21467C2.36683 3.20801 2.27266 3.20801 2.0835 3.20801",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDCart);
export default __webpack_public_path__ + "static/media/D_cart.874e63f4eb4a610d9d37fa822b096c5a.svg";
export { ForwardRef as ReactComponent };